/* eslint-disable */
import React, { useState } from "react";
import AttendanceCard from "./components/cards/cards";
import AttendanceChart from "./components/attendancechart/attendanceChart";
import AttendanceReportTable from "./components/attendancetable/attendanceReportTable";
import {
  Button,
  Card,
  Divider,
  Grid,
  Group,
  Modal,
  Text,
  Title,
} from "@mantine/core";
import { useDownloadAttendanceExcel } from "api/attendanceReport/getAttendanceReportExcelDownload";
import {
  useDownloadAttendanceTemplate,
  useImportAttendanceReport,
} from "api/attendanceReport/attendanceImport";
import { UserPlus, FileDownload, FileUpload } from "tabler-icons-react";
import { useDisclosure } from "@mantine/hooks";
import { PermissionButton } from "api/permission/buttonpermission";
import ReportImportModal from "components/ReportImportModal";

export default function AttendanceReport() {
  const { mutate, isLoading } = useDownloadAttendanceExcel();
  const downloadTemplate = useDownloadAttendanceTemplate();
  const importAttendance = useImportAttendanceReport();
  const [tableFilters, setTableFilters] = useState<any>({});
  const [opened, { open, close }] = useDisclosure(false);
  const [importOpened, { open: openImport, close: closeImport }] =
    useDisclosure(false);

  // Shared date range for both the chart and the table, so they always
  // agree on the window of data they're showing instead of the chart
  // defaulting to the full year while the table defaulted to "today only".
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>(
    () => {
      const now = new Date();
      return [new Date(now.getFullYear(), 0, 1), now];
    }
  );
  const handleExport = () => {
    mutate({
      startDate: tableFilters.startDate,
      endDate: tableFilters.endDate,
      department: tableFilters.department,
      status: tableFilters.status,
      employeeName: tableFilters.employeeName,
      search: tableFilters.search,
    });
  };
  return (
    <div>
      <ReportImportModal
        opened={importOpened}
        onClose={closeImport}
        title="Import Attendance Report"
        onImport={(file) => importAttendance.mutateAsync(file)}
        isImporting={importAttendance.isLoading}
      />
      <Modal
        opened={opened}
        onClose={close}
        centered
        size="md"
        radius="md"
        padding="xl"
        title={
          <Text fw={600} fz="lg">
            Confirm Excel Download
          </Text>
        }
      >
        <Text size="lg" mt="sm" mb="xl" color="dimmed">
          Are you sure you want to download the attendance report Excel file?
        </Text>

        <Group position="apart" mt="xl">
          <Button color="cancel" onClick={close} size="md">
            Cancel
          </Button>

          <Button
            size="md"
            loading={isLoading}
            onClick={() => {
              handleExport();
              close();
            }}
          >
            Yes, Download
          </Button>
        </Group>
      </Modal>

      <Grid>
        <Grid.Col span={12}>
          <Group position="apart">
            <Title order={2}> Attendance Report</Title>
            <Group>
              {/* <PermissionButton
                permission="reports.attendancereportDownload"
                leftIcon={<UserPlus size={16} />}
                onClick={open}
                loading={isLoading}
              >
                Attendance Report Download
              </PermissionButton> */}
              <Button
                leftIcon={<UserPlus size={16} />}
                onClick={open}
                loading={isLoading}
                // onClick={() => setOpened(true)}
              >
                Attendance Report Download
              </Button>
              <PermissionButton
                permission="reports.attendanceTemplate"
                hideIfNo
                variant="light"
                leftIcon={<FileDownload size={16} />}
                onClick={() => downloadTemplate.mutate()}
                loading={downloadTemplate.isLoading}
              >
                Download Sample Template
              </PermissionButton>
              <PermissionButton
                permission="reports.attendanceImport"
                hideIfNo
                variant="light"
                leftIcon={<FileUpload size={16} />}
                onClick={openImport}
              >
                Import Report
              </PermissionButton>
            </Group>
          </Group>
          {/* <Divider mb="md" /> */}
        </Grid.Col>
        <Grid.Col span={6}>
          <Card radius="md">
            <AttendanceCard />
          </Card>
        </Grid.Col>
        <Grid.Col span={6}>
          <AttendanceChart dateRange={dateRange} />
        </Grid.Col>
        <Grid.Col span={12}>
          <AttendanceReportTable
            dateRange={dateRange}
            onDateRangeChange={setDateRange}
            onFilterChange={setTableFilters}
          />
        </Grid.Col>
      </Grid>
    </div>
  );
}
